/** Translate unclaimed server slots into the same coordinate space as claimed previews. */
export function pendingSlotPosition(planned:{x:number;y:number}, anchors:Array<{planned:{x:number;y:number};current:{x:number;y:number}}>) {
 if (!anchors.length) return planned;
 const median=(values:number[])=>values.sort((a,b)=>a-b)[Math.floor(values.length/2)];
 return {x:planned.x+median(anchors.map(a=>a.current.x-a.planned.x)),y:planned.y+median(anchors.map(a=>a.current.y-a.planned.y))};
}
